import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";

import "./style.scss";

import $ from "jquery";

import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";

export function initPhotoSwipe(galleryElement) {
  if (!galleryElement) return;

  const $images = $(galleryElement).find("img");

  const items = $images.get().map((el) => {
    const $img = $(el);

    return {
      title: $img.attr("alt"),
      src: $img.attr("data-full-url"),
      w: $img.attr("data-full-width"),
      h: $img.attr("data-full-height"),
      msrc: $img.attr("data-src"),
      el,
    };
  });

  const options = {
    getThumbBoundsFn(id) {
      const pageYScroll = $(window).scrollTop();
      const { top, left, width } = items[id].el.getBoundingClientRect();

      return { x: left, y: top + pageYScroll, w: width };
    },
    bgOpacity: 1,
    history: false,
  };

  $images.on("click", (evt) => {
    evt.preventDefault();

    new PhotoSwipe($(".pswp").get(0), PhotoSwipeUI_Default, items, {
      ...options,
      index: $images.index(evt.target),
    }).init();
  });
}

initPhotoSwipe($(".work-page-gallery__content").get(0));
